<template>
	<div
		class="g-block-contact-info"
		:class="{
			'g-block-contact-info--edit': editable,
			'is-active': editable && active,
			'g-block-contact-info--h5': h5,
		}"
		@click="onWrapClick"
	>
		<ContactInfoPreview :data="contactData" :h5="h5" :interactive="!editable" />
	</div>
</template>

<script>
	import ContactInfoPreview from '../../../components/ContactInfoPreview.vue';
	import { normalizeContactInfoData } from '../../../utils/contactInfo.js';

	export default {
		name: 'GBlockContactInfo',
		components: { ContactInfoPreview },
		props: {
			data: {
				type: Object,
				required: true,
			},
			editable: {
				type: Boolean,
				default: false,
			},
			active: {
				type: Boolean,
				default: false,
			},
			h5: {
				type: Boolean,
				default: false,
			},
		},
		emits: ['select'],
		computed: {
			contactData() {
				return normalizeContactInfoData(this.data);
			},
		},
		methods: {
			onWrapClick() {
				if (this.editable) {
					this.$emit('select');
				}
			},
		},
	};
</script>

<style scoped lang="less">
	.g-block-contact-info {
		box-sizing: border-box;

		&--edit {
			border: 1px solid transparent;
			border-radius: 4px;
			transition: border-color 0.2s, box-shadow 0.2s;
			cursor: pointer;

			&.is-active {
				border-color: #285af9;
				box-shadow: 0 0 0 1px rgba(40, 90, 249, 0.15);
			}
		}
	}
</style>
